import { render, staticRenderFns } from "./JsDosSaveAlert.vue?vue&type=template&id=55e15bbf&"
import script from "./JsDosSaveAlert.vue?vue&type=script&lang=js&"
export * from "./JsDosSaveAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports